export default "__VITE_ASSET__DXzoNyUE__"